<script>
    import { api_host } from "../../stores.js";
    import { getToken, doFetch } from '../../utils/Fetching.js';
    import { onMount } from 'svelte';
    import Header from "../header.svelte";
    import IFTAInput from "../../utils/iftainput.svelte";
    import { toast_message } from '../../utils/toast_message.js';
    import ResponsiveTable from '../../utils/responsivetable3.svelte';
    import { expense_category_store } from '../../stores.js';
    import { init_data } from '../../init.js';
    import Swal from "sweetalert2";


    const { auth_type, auth_token, domain_code } = getToken();

    let content_title = "Expense Category";
    let is_busy = false;
    let is_creating = true;
    let update_category_id = 0;
    let expense_categories = [];

    onMount(async () => {
        init_data('expense_category');
    });

    expense_category_store.subscribe((value) => {
        let _expense_categories = [];
        for (let i = 0; i < value.length; i ++) {
            const _expense_category = value[i];
            _expense_categories.push({
                "id": _expense_category.id,
                "an": _expense_category.account_name,
                "desc": _expense_category.description,
                "at": _expense_category.account_type
            });
        }
        expense_categories = _expense_categories;
    });

    let table_header_config = [
        {'t': 'Account Name', 'fm': 'an', 'a': true},
        {'t': 'Description', 'fm': 'desc', 'a': true},
        {'t': 'Account Type', 'fm': 'at', 'a': true},
    ];


    let action_items = [
        {"id": "edit", "i": "fas fa-edit", "s": "color: #1c54b2;", "f": (id) => {
            const expense_category = expense_categories.filter(obj => { return obj.id === id; });
            if (expense_category.length == 1) {
                is_creating = false;
                fields[0].value = expense_category[0]['an'];
                fields[1].value = expense_category[0]['at'];
                fields[2].value = expense_category[0]['desc'];
                update_category_id = id;
            }
        }},
        {"id": "delete", "i": "fas fa-trash-alt", "s": "color: #ab003c;", "f": (id) => {
            Swal.fire({
                title: "Delete this expense category?",
                text: '',
                buttonsStyling: true,
                confirmButtonClass: "button",
                confirmButtonText: 'Ok',
                cancelButtonText: "Cancel",
                showCancelButton: true,
                icon: "warning"
            }).then(async (e) => {
                is_busy = true;
                if (e.isConfirmed) {
                    const res = await doFetch(
                        `${api_host}/api/expense/category/delete`,
                        'POST',
                        { id },
                        { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
                    );
                    console.log(res);
                    if (res.status) {
                        toast_message(true, res.msg, 2000);
                        init_data('expense_category');
                    } else {
                        toast_message(false, res.msg || 'Bad request', 2000);
                    }
                }
                is_busy = false;
            });
        }},
    ];

    let fields = [
        {
            "index": 0,
            "group": "row1",
            "type": "text",
            "label": "Account Name",
            "value": "",
            "placeholder": "eg. Labor",
            "validation_function": () => {
                if (fields[0].value.length > 0) {
                    fields[0]['show_error'] = false;
                    return true;
                } else {
                    fields[0]['show_error'] = true;
                    fields[0]['error_text'] = 'Account Name is required';
                    return false;
                }
            },
        },
        {
            "index": 1,
            "group": "row1",
            "type": "select",
            "label": "Account Type",
            "value": "Cost of Revenue",
            "select_options": ["Cost of Revenue", "Expense"],
        },
        {
            "index": 2,
            "group": "row2",
            "type": "text",
            "label": "Description",
            "value": "",
            "placeholder": "eg. Promo code to acquire new clients.",
        }
    ];

    let validateForm = () => {
        let is_valid = true;
        fields.forEach(field => {
            if (field.validation_function && !field.validation_function()) {
                is_valid = false;
            }
        });

        return is_valid;
    };

    let refresh_category_form = () => {
        is_creating = true;
        fields[0].value = '';
        fields[2].value = '';
    }

    let createCategory = async () => {
        if (validateForm()) {
            const payload = {
                'account_name': fields[0].value,
                'account_type': fields[1].value,
                'description': fields[2].value,
            };
            is_busy = true;
            const res = await doFetch(
                `${api_host}/api/expense/category/add`,
                'POST',
                payload,
                { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
            );
            if (res.status) {
                toast_message(true, res.msg, 2000);
                init_data('expense_category');
                refresh_category_form();
            } else {
                toast_message(false, res.msg || 'Bad request', 2000);
            }
            is_busy = false;
        } else {
            toast_message(false, 'Missing or invalid info', 3000);
        }
    };

    let updateCategory = async () => {
        if (validateForm()) {
            const payload = {
                'id': update_category_id,
                'account_name': fields[0].value,
                'account_type': fields[1].value,
                'description': fields[2].value,
            };
            is_busy = true;
            const res = await doFetch(
                `${api_host}/api/expense/category/update`,
                'POST',
                payload,
                { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
            );
            if (res.status) {
                toast_message(true, res.msg, 2000);
                init_data('expense_category');
                refresh_category_form();
            } else {
                toast_message(false, res.msg || 'Bad request', 2000);
            }
            is_busy = false;
        } else {
            toast_message(false, 'Missing or invalid info', 3000);
        }
    }

    let date_value = '';
</script>


<Header bind:title={content_title} bind:is_busy={is_busy} />

<div class="contentholder">
    <div class="section cardinfo">
        <div class="sectionsubtitle">{is_creating ? 'Add new expense category' : 'Edit'}</div>

        <div class="ff formrow">
            {#each fields.filter((e)=>e.group === "row1") as nf}
            <IFTAInput
                type={(nf.type !== undefined) ? nf.type : ""}
                label={(nf.label !== undefined) ? nf.label : ""}
                placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""}
                helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""}
                select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                readonly={nf.readonly}
                disabled={nf.disabled}
                show_error={nf.show_error}
                error_text={nf.error_text}
                bind:hidden={nf.hidden}
                bind:value={nf.value}
                bind:change_function={nf.change_function}
                bind:validation_function={nf.validation_function}
                bind:extFuncs={nf.ext_funcs}
            />
            {/each}        
        </div>                

        <div class="ff formrow">
            {#each fields.filter((e)=>e.group === "row2") as nf}
            <IFTAInput
                type={(nf.type !== undefined) ? nf.type : ""}
                label={(nf.label !== undefined) ? nf.label : ""}
                placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""}
                helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""}
                select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                readonly={nf.readonly}
                disabled={nf.disabled}
                show_error={nf.show_error}
                error_text={nf.error_text}
                bind:hidden={nf.hidden}
                bind:value={nf.value}
                bind:change_function={nf.change_function}
                bind:validation_function={nf.validation_function}
                bind:extFuncs={nf.ext_funcs}
            />
            {/each}
        </div>

        <div class="updatebutton">
            {#if is_creating}
                <button class="save" on:click={() => { createCategory(); }}>Create</button>
            {:else}
                <button class="save" on:click={() => { updateCategory(); }}>Save</button>
                &nbsp;&nbsp;
                <button class="cancel" on:click={() => { refresh_category_form(); }}>Cancel</button>
            {/if}
        </div>
    </div>

    <div class="section expensecategorytable">
        <div class="sectionsubtitle">Categories</div>
        <ResponsiveTable
            table_data={expense_categories}
            num_per_page={100}
            show_date_range={false}
            refresh_action='expense_category'
            bind:table_header_config={table_header_config}
            bind:date_value={date_value}
            bind:total_items={expense_categories.length}
            bind:action_items={action_items}
        />
    </div>
</div>


<style>
    .ff {
        padding: 10px;
        width: 100%;
    }
    :global(.ff .group) {
        margin-left: 5px;
        margin-right: 5px;
    }
    .formrow {
        padding: 0px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
    }
    .contentholder {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        grid-template-rows: auto;
        grid-template-areas: "ci ci ci ci ci ci ci ci ci ci ci ci"
                             "ct ct ct ct ct ct ct ct ct ct ct ct";
        gap: 20px;
    }
    .cardinfo {
        grid-area: ci;
    }
    .updatebutton {
        grid-area: ub;
        display: flex;
        flex-direction: row;
        justify-content: start;
    }
    .updatebutton .save {
        padding-left: 25px;
        padding-right: 25px;
        background-color: #357a38;
        color: white;
    }
    .updatebutton .cancel {
        padding-left: 25px;
        padding-right: 25px;
        background-color: #b2102f;
        color: white;
    }
    .expensecategorytable {
        grid-area: ct;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .ff {
            padding: 10px;
            width: 100%;
        }
        .formrow {
            width: 100%;
            padding: 0px;
            display: flex;
            flex-direction: column;
        }
        .contentholder {
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            grid-template-rows: auto;
            grid-template-areas: "ci"
                                 "ct";
            gap: 20px;

        }
        .cardinfo {
            grid-area: ci;
        }
        .updatebutton {
            grid-area: ub;
            display: flex;
            flex-direction: column;
            padding: 0px;
        }
        .updatebutton .save {
            width: 100%;
            background-color: #357a38;
            color: white;
        }
        .updatebutton .cancel {
            width: 100%;
            background-color: #b2102f;
            color: white;
        }
        .expensecategorytable {
            grid-area: ct;
            width: 100%;
            max-width: 100%;
            overflow-x: scroll;
        }
    }
</style>